import {SmartComponent} from "smart-component-js";

class ShareComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.sharedData = {};
        this.trigger = this.element.querySelector(".share__trigger");
        this.popup = this.element.querySelector(".share__popup");
        this.closeButton = this.element.querySelector(".share__popup-close");

        this.init();
    }

    initShareData() {
        this.sharedData.title = document.head.title || 'DonnaD Amica fidata';
        this.sharedData.text = document.body.querySelector('h1')?.innerText || 'DonnaD Amica fidata';
        this.sharedData.url = window.location.href;
    }

    addShareButtonListener() {
        this.initShareData();
        this.addShareDesktop();
        // (!navigator.canShare) ? this.addShareDesktop() : this.addShareMobile();
    }

    addShareDesktop() {
        const shareButtons = this.element.querySelectorAll('.share__popup-option');
        shareButtons.forEach((button) => {
            button.addEventListener('click', () => this.share(button));
        });
    }

    share(element) {
        const url = this.getUrlToShare(element);
        if(!url) return;
        window.open(url, '_blank');
    }

    getUrlToShare(element) {
        const type = element.dataset.type;
        switch (type) {
            case 'facebook':
                return `https://www.facebook.com/sharer/sharer.php?u=${this.sharedData.url}`;
            case 'pinterest':
                return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.sharedData.url)}&description=${encodeURIComponent(this.sharedData.text)}`;
            case 'whatsapp':
                return `https://api.whatsapp.com/send?text=${this.sharedData.url}`;
            case 'mail':
                const message = this.sharedData.text + ': ' + this.sharedData.url;
                return `mailto:?subject=${this.sharedData.title}&body=${encodeURIComponent(message)}`;
        }
    }

    togglePopup() {
        this.element.classList.toggle("active");
    }

    closePopup() {
        this.element.classList.remove("active");
    }

    addPopupListener() {
        if(!this.popup) return;
        this.trigger.addEventListener("click", () => this.togglePopup());
        this.closeButton.addEventListener("click", () => this.closePopup());
        document.addEventListener("click", (event) => {
            if (!this.element.contains(event.target)) {
                this.closePopup();
            }
        });
    }

    init() {
        this.addPopupListener();
        this.addShareButtonListener();
    }
}

export default ShareComponent;
